module.exports = __WEBPACK_EXTERNAL_MODULE_ykxQ__;


//////////////////
// WEBPACK FOOTER
// external "bootstrap"
// module id = ykxQ
// module chunks = 0